import React, { Component } from "react";
import "./Fcm.css";
import NotificationSystem from "react-notification-system";
import Modal from "react-responsive-modal";
import ImageNotification from "../../../../assets/img/icons/fcm.png";
import { withRouter } from "react-router-dom";
import { FIREBASE_VAPID_KEY } from "../../../utility/constants";
import messaging from "../../../firebase";
import { signInAnonymouslyToFirebase, setupOnMessageListener } from "../../../firebase";
import NotificationContent from "./NotificationContent";


const _notificationSystem = null;

class Fcm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            next: true,
            open: false,
            mensaje: "",
        };

        this.activarNotificacionesPush = this.activarNotificacionesPush.bind(this);
        this.validarToken = this.validarToken.bind(this);
        this._addNotification = this._addNotification.bind(this);
    }

    componentWillMount() {
        // Valir si se estan usando las Notificaciones Push
        this.validarUsoNotificacionesPush();
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;

        // Escuchar mensajes enviados desde Root.jsx
        window.addEventListener('fcm-message', (event) => {
            const payload = event.detail;
            const { title, body, click_action, } = payload.notification || {};

            this._addNotification({ title, body, click_action });
        });
    }

    validarUsoNotificacionesPush = async () => {
        try {
            // Verificar si el navegador soporta notificaciones
            if (!("Notification" in window)) {
                console.error("Este navegador no soporta notificaciones");
                return;
            }

            const permission = Notification.permission;
            if (permission === "granted") {
                await this.validarToken(); // Obtener el token
            }
			else if (permission === "default") {
                this.onOpenModal();
                if (this.props.setHideAlert) this.props.setHideAlert(true);
            }
            else if (!window.isSecureContext) console.error("Sitio no seguro.");
			else if (permission === "denied") console.error("Notificaciones bloqueadas por el usuario.");

        }
		catch (error) {
            console.error("Error al verificar permisos:", error);
        }
    };

    validarToken = async () => {
        messaging
            .getToken()
            .then((currentToken) => {
                if (currentToken) {
                    console.log("Token existente: ", currentToken);

                    // Verifica el estado actual
                    console.info('Permiso:', Notification.permission);

					this.props.newToken(currentToken);
                } else {
                    this.onOpenModal();
                    if (this.props.setHideAlert) {
                        this.props.setHideAlert(true);
                    }
                }
            })
            .catch((error) => {
                console.error("Error al verificar token FCM:", error);
            });
    };

    activarNotificacionesPush = async () => {
        // console.log("Solicitando permiso y generando token FCM");

        try {
            // Logear automaticamente como Usuario Anonimo en Firebase
            const user = await signInAnonymouslyToFirebase();
            // if (user) console.log("UID del usuario anónimo:", user.uid);

            // Obtener Token para recibir las Notificaciones Push
            const currentToken = await messaging.getToken({vapidKey: FIREBASE_VAPID_KEY});
            if (currentToken) {
                console.log("Token FCM generado:", currentToken);
                this.props.newToken && this.props.newToken(currentToken);
                this.onCloseModal();
            }
			else {
                console.error("No se pudo generar un token FCM.");
            }
        } catch (error) {
            console.error("Error al obtener token:", error);
        }

    };

    onOpenModal = () => this.setState({ open: true });
    onCloseModal = () => this.setState({ open: false });
    onClickNotify = (link) => this.props.history.push(link);

/*
_addNotification = (notification) => {
    this._notificationSystem.addNotification({
      children: (
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-4 d-flex align-items-center">
            <img className="icono" src={ImageNotification} alt="genesis"/>
          </div>
          <div className="col-lg-8 col-md-8 col-sm-8">
              <p className="font-weight-bold" style={{color:'white'}} >{notification.title}</p>
              <p  style={{color:'white'}} >{notification.body}</p>
          </div>

        </div>
      ),
      level: 'info',
      position:'br',
      dismissible:true,
      autoDismiss:0,
      action: {
        label: 'Ir al sitio',
        callback: function() {
          console.log('Notification button clicked!');
        }
      }
    });
  }
*/

    _addNotification = (notification) => {
        this._notificationSystem.addNotification({
            children: (
                <NotificationContent
                    title={notification.title}
                    body={notification.body}
                    onClick={() => this.onClickNotify(notification.click_action)}
                />
            ),
            level: "info",
            position: "br",
            dismissible: true,
            autoDismiss: 0,
            style: {
                NotificationItem: {
                    DefaultStyle: {
                        background: "transparent",
                        border: "none",
                        boxShadow: "none",
                        padding: 0,
                        margin: 0,
                    },
                    info: {
                        background: "transparent",
                        border: "none",
                        boxShadow: "none",
                        padding: 0,
                        margin: 0,
                    },
                },
                Containers: {
                    br: {
                        background: "transparent",
                        border: "none",
                        boxShadow: "none",
                    },
                },
            },
        });
    };

    render() {
        const { open, next } = this.state;

        return (
            <div>
                <NotificationSystem ref="notificationSystem" />

                {/* Modal de permiso FCM */}
                <Modal open={open} onClose={this.onCloseModal} little>
                    {next ? (
                        <div className="modal-container">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-sm-8 offset-lg-4 offset-md-3 offset-sm-2 text-center">
                                    <div className="panel-body">
                                        <img
                                            src={require("../../../../assets/img/alertas/notificacion1fcm.png")}
                                            alt="Permitir notificaciones"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="text-center txt">
                                <span className="reset-caption">
                                    El sistema necesita enviarte notificaciones
                                    para mantenerte actualizado.
                                </span>
                                <br />
                                <span className="reset-caption">
                                    ¿Deseas recibir estas notificaciones?
                                </span>
                            </div>
                            <div className="text-center botones">
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.onCloseModal();
                                    }}
                                    className="btn btn-action mt-lg later"
                                    type="submit"
                                >
                                    Más tarde
                                </button>
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({ next: false });
                                    }}
                                    className="btn btn-default mt-lg"
                                    type="submit"
                                >
                                    Aceptar
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="modal-container">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-8 offset-lg-3 offset-md-3 offset-sm-2 text-center">
                                    <div className="panel-body">
                                        <img
                                            className="alert-permitir"
                                            src={require("../../../../assets/img/alert-permitir.png")}
                                            alt="Permitir notificaciones"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="text-center txt">
                                <span className="reset-caption">
                                    Te aparecerá un mensaje como el de la
                                    imagen.
                                </span>
                                <br />
                                <span className="reset-caption">
                                    Es necesario que des clic en <b>Permitir</b>{" "}
                                    para activar las notificaciones.
                                </span>
                            </div>
                            <div className="text-center">
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.activarNotificacionesPush();
                                    }}
                                    className="btn btn-default mt-lg botones"
                                    type="submit"
                                >
                                    Aceptar
                                </button>
                            </div>
                        </div>
                    )}
                </Modal>
            </div>
        );
    }
}

export default withRouter(Fcm);
